<template>
    <aside>
        <h1>shades</h1>
        <section>
            <input type="text" v-model="filter" placeholder="shade search" />
            <ul>
                <Expandable v-for="details in filteredShades" :key="details.productId" :name="details.productName[$t('trad')].value">
                    <ul>
                        <ShadeListTile
                            v-for="shade in details.shades"
                            :key="shade.id"
                            :shade="shade"
                            :selected="shadeSelected && shade.id === shadeSelected.id"
                            @selectShade="selectShade"
                        ></ShadeListTile>
                    </ul>
                </Expandable>
            </ul>
        </section>
    </aside>
</template>

<script>
import Expandable from "@/plano/components/expandable";
import ShadeListTile from "./shade-list-tile";

export default {
    components: { Expandable, ShadeListTile },
    data: () => ({ filter: "" }),
    props: {
        shades: {
            /** @type {{ productId: number, productName: Translation, shades: Shade[] }[]} */
            type: Array,
            required: true
        },
        shadeSelected: {
            type: Object
        }
    },
    methods: {
        selectShade(shade) {
            this.$emit("selectShade", shade);
        }
    },
    computed: {
        filteredShades() {
            const reg = new RegExp(this.filter, "i");

            const result = [];
            for (const shade of this.shades) {
                const filteredShadePerProduct = shade.shades.filter(shade => {
                    return (
                        reg.test(shade.name) ||
                        reg.test(
                            (shade.properties &&
                                shade.properties.number &&
                                shade.properties.number.numb1 &&
                                shade.properties.number.numb1.value.toString()) ||
                                ""
                        ) ||
                        reg.test(
                            (shade.properties &&
                                shade.properties.reference &&
                                shade.properties.reference.client_ref1 &&
                                shade.properties.reference.client_ref1.value.toString()) ||
                                ""
                        )
                    );
                });

                if (filteredShadePerProduct.length > 0) {
                    result.push({
                        ...shade,
                        shades: filteredShadePerProduct
                    });
                }
            }
            return result;
        }
    }
};
</script>

<style scoped lang="scss">
aside {
    border-left: 1px #777 solid;
    display: flex;
    flex-direction: column;

    h1 {
        background-color: #777;
        margin: 0;
        text-transform: uppercase;
        font-size: 1.5em;
        padding: 3px 10px;
        color: white;
    }

    > section {
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        padding-left: 20px;

        > input {
            margin-right: 20px;
        }
        ul {
            padding: 0;
            margin: 0;
        }

        > ul {
            flex-grow: 1;
            display: flex;
            flex-direction: column;
            overflow: auto;
            flex-basis: 0;
            padding: 0;
            padding-right: 20px;
            margin: 0;
        }
    }
}
</style>



// WEBPACK FOOTER //
// shades-catalog.vue?51664760